var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKamleonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2283,
    height: 300,
    viewBox: "0 0 2283 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2882 174.312L58.1482 213.568V293.52H0V6.125H58.1482V136.497L178.196 6.125H254.727L136.18 131.455L255.852 293.52H182.698L95.6632 174.312H95.2882Z",
    fill: "#221E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.256 227.974H349.707L324.947 293.52H263.423L378.219 6.125H445.746L559.791 293.52H496.391L471.256 227.974ZM369.215 176.833H452.123L410.857 68.0698L369.59 176.833H369.215Z",
    fill: "#221E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M874.445 293.872V92.1909L788.16 293.872H739.391L653.106 93.9916V293.872H597.209V6.47656H674.115L764.151 214.28L851.936 6.47656H931.468V293.872H874.07H874.445Z",
    fill: "#221E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M999.837 293.871V6.47656H1057.99V240.57H1191.54V294.232H999.837V293.871Z",
    fill: "#221E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.1 293.872V6.47656H1423.67V59.0576H1294.25V124.604H1411.29V174.664H1294.25V241.291H1423.67V293.872H1236.1Z",
    fill: "#221E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1617.27 0C1698.68 0 1771.46 57.2629 1771.46 150.18C1771.46 243.097 1698.68 300 1617.27 300C1535.86 300 1463.46 242.737 1463.46 150.18C1463.46 57.6231 1536.24 0 1617.27 0ZM1617.27 245.258C1663.79 245.258 1711.06 214.286 1711.06 149.46C1711.06 84.6339 1663.79 53.6615 1617.27 53.6615C1570.75 53.6615 1523.86 84.6339 1523.86 149.46C1523.86 214.286 1571.13 245.258 1617.27 245.258Z",
    fill: "#221E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2016.04 293.872L1879.86 90.03V293.872H1821.72V6.47656H1894.5L2019.05 196.633V6.47656H2077.57V293.872H2016.42H2016.04Z",
    fill: "#221E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2201.74 2.87988C2246.01 2.87988 2282.77 37.8138 2282.77 80.3108C2282.77 122.808 2246.01 157.742 2201.74 157.742C2157.47 157.742 2121.08 122.808 2121.08 80.3108C2121.08 37.8138 2157.47 2.87988 2201.74 2.87988ZM2201.74 137.574C2234.75 137.574 2260.26 112.364 2260.26 80.3108C2260.26 48.258 2234.38 23.0479 2201.74 23.0479C2169.1 23.0479 2143.22 48.258 2143.22 80.3108C2143.22 112.364 2168.73 137.574 2201.74 137.574ZM2199.86 92.5558H2194.99V118.846H2171.73V39.2544H2207.37C2223.87 39.2544 2236.63 51.1392 2236.63 65.9051C2236.63 75.9891 2230.62 84.2724 2222 88.234L2237.38 118.486H2212.24L2200.24 92.1956L2199.86 92.5558ZM2201.74 74.1884C2208.12 74.1884 2212.24 71.3073 2212.24 65.9051C2212.24 59.7826 2208.12 57.9819 2201.74 57.9819H2194.99V74.1884H2201.74Z",
    fill: "#221E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKamleonLogo);
export default __webpack_public_path__ + "static/media/kamleon_logo.114bd067608c4706f07ab469aa78a9a2.svg";
export { ForwardRef as ReactComponent };